import { create } from "zustand";

type TagData = {
  episodeIds: string[];
  name: string;
};

type TagModalState = {
  isOpen: boolean;
  tagModalData: TagData | null;
  isTagRemovePending: boolean;
  openModal: (tagModalData: TagData) => void;
  closeModal: () => void;
  setIsTagRemovePending: (isPending: boolean) => void;
};

export const useTagModalStore = create<TagModalState>((set) => ({
  isOpen: false,
  tagModalData: null,
  isTagRemovePending: false,
  openModal: (tag) =>
    set({
      isOpen: true,
      tagModalData: tag,
    }),

  closeModal: () => {
    set({ isOpen: false });
    setTimeout(() => set({ tagModalData: null }), 300); // Clear data after modal close animation
  },
  setIsTagRemovePending: (isPending) => set({ isTagRemovePending: isPending }),
}));
